import React from 'react';
import { ChefHat, Heart, Award } from 'lucide-react';

const Presentation = () => {
  return (
    <section id="presentation" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left: Photo */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="/images/bob2.jpg"
                alt="Chef Robert - Du Sourire à la Fourchette"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal/60 to-transparent"></div>
            </div>

            {/* Decorative element */}
            <div className="absolute -top-6 -left-6 w-48 h-48 bg-gold/20 rounded-full blur-3xl -z-10"></div>
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-burgundy/20 rounded-full blur-3xl -z-10"></div>
          </div>

          {/* Right: Content */}
          <div>
            <div className="inline-flex items-center gap-2 bg-gold/10 px-4 py-2 rounded-full mb-6">
              <ChefHat className="w-5 h-5 text-gold" />
              <span className="text-gold font-semibold">Robert - Votre Traiteur</span>
            </div>

            <h2 className="text-4xl sm:text-5xl font-bold text-charcoal mb-6">
              Qui suis-je ?
            </h2>
            <div className="w-24 h-1 bg-gold mb-8"></div>

            <p className="text-lg text-charcoal/80 mb-6 leading-relaxed">
              Après une reconversion professionnelle, j'ai amélioré mes connaissances en obtenant mon CAP de cuisine pour assouvir ma passion de la cuisine. Aujourd'hui, je vis pleinement de ce qui m'anime : <strong>le plaisir de partager des moments de convivialité</strong> autour de bons plats.
            </p>

            <p className="text-lg text-charcoal/80 mb-6 leading-relaxed">
              Ce qui me passionne le plus ? <strong>Échanger avec vous pendant la préparation</strong>, cuisiner en direct devant vos invités, créer cette ambiance chaleureuse qui fait toute la différence. Mes spécialités : <strong>paella, mechoui, couscous, cochon grillé, buffets chauds et froids</strong>... et bien d'autres plats !
            </p>

            <p className="text-lg text-charcoal/80 mb-8 leading-relaxed">
              Ma philosophie ? La <strong>générosité</strong> et le plaisir simple d'une <strong>cuisine traditionnelle et authentique</strong>, préparée avec des <strong>produits frais et de qualité</strong>. Chaque événement est unique, et je m'adapte à vos envies pour créer des moments inoubliables.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-12 h-12 bg-gold/10 rounded-full flex items-center justify-center">
                  <Heart className="w-6 h-6 text-gold" strokeWidth={2} />
                </div>
                <div>
                  <h3 className="font-bold text-charcoal mb-1">Convivialité</h3>
                  <p className="text-charcoal/70 text-sm">Partager, échanger et créer des moments chaleureux</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-12 h-12 bg-gold/10 rounded-full flex items-center justify-center">
                  <Award className="w-6 h-6 text-gold" strokeWidth={2} />
                </div>
                <div>
                  <h3 className="font-bold text-charcoal mb-1">Authenticité</h3>
                  <p className="text-charcoal/70 text-sm">Cuisine traditionnelle avec des produits frais</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Presentation;
